import { forwardRef, HTMLAttributes } from "react";
import ReCAPTCHA from "react-google-recaptcha";

// ----------------------------------------------------------------------------
// Render-noop preserved for API compatibility with the 9 form components that
// still write <GoogleReCaptcha ref={reCaptchaRef} />. The actual <ReCAPTCHA>
// instance now lives once at the root in <ReCaptchaProvider>, which is what
// makes reCAPTCHA's 373 KB recaptcha__en.js load once per page instead of
// once per form. The ref passed here is intentionally not attached to anything;
// the hook + provider share their own ref under the hood.
// ----------------------------------------------------------------------------

export type IGoogleReCaptchaProps = HTMLAttributes<HTMLDivElement> & {};

const GoogleReCaptcha = forwardRef<ReCAPTCHA, IGoogleReCaptchaProps>(
  function GoogleReCaptcha() {
    return null;
  },
);

export default GoogleReCaptcha;
